<nav id="topmenu" *ngIf="!sharedDataService.isAppWebView()"  class="navbar navbar-expand-lg navbar-light bg-light"
  [ngClass]="{'navbar-open': isnavbar,'topmenu-no-margin': (hasWellnessMembership || isMemberPortalOnly)}">
  <div class="navbar-header">
    <a class="navbar-brand" href="javascript:void(0);">
      <img [width]="iconWidth" [src]="logoIcon" class="primary-logo d-none d-sm-block" alt="WOW LOGO" />
      <img [width]="iconWidthMobile" [src]="logoIconMobile" class="primary-logo d-sm-none" alt="WOW LOGO" />
    </a>
    <div class="mobile-nav d-flex align-items-center">
      <li class="nav-item ">
        <a class="nav-link phone-btn" [href]="'tel:'+environment.phoneNumber" aria-expanded="false">
          <img [src]="sharedService.imagesUrl + 'icons/phone-icon-nav-update.svg'"
            [alt]="'Call '+environment.phoneNumberToShow" />
        </a>
      </li>
      <ul class="navbar-nav Em-main-mobile-ul bg-transparent">
        <li class="nav-item  En-li dropdown" class="nav-item dropdown " routerLinkActive="active">

          <a routerLinkActive="active" class="nav-link phone-btn en-btn dropdown-toggle" href="#" id="navbarDropdown"
            role="button" data-bs-toggle="dropdown" aria-expanded="false">
            <span class="En-span">
              <img width="17" [src]="sharedService.imagesUrl +  'icons/En.svg'" alt="DOWN ARROW">


              <span>{{currentLanguage.toUpperCase()}}</span>
            </span>
          </a>
          <ul class="dropdown-menu En-menue  bordered-menu-en " aria-labelledby="navbarDropdown">
            <li>
              <a class="dropdown-item" (click)="setLanguage('en'); navclose()">English (EN)</a>
            </li>
            <li class="center-li" routerLinkActive="active"><a class="dropdown-item"
                (click)="setLanguage('es'); ">Spanish
                (ES)
              </a></li>
            <li class="border-0 end-li  " routerLinkActive="active">
              <a class="dropdown-item end-btn" (click)="setLanguage('zh'); navclose()">
                Chinese (ZH)

              </a>
            </li>
          </ul>
        </li>
      </ul>
      <button (click)="toggleNavbar()" *ngIf="!sharedService.hideburgerMenu" class="navbar-toggler" type="button"
        aria-controls="navbarSupportedContent" [attr.aria-expanded]="isnavbar" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon-custom" [class.active]="isnavbar">
          <span class="inner-span" [class.active]="isnavbar"></span>
        </span>
      </button>
    </div>

  </div>
  <div class="container">
    <a class="navbar-brand main-brand" href="javascript:void(0);">
      <img [width]="iconWidth" [src]="logoIcon" class="primary-logo d-none d-sm-block" alt="WOW LOGO" />
      <img [width]="iconWidthMobile" [src]="logoIconMobile" class="primary-logo d-sm-none" alt="WOW LOGO" />
    </a>
    <button (click)="toggleNavbar()" *ngIf="!sharedService.hideburgerMenu" class="navbar-toggler hide-toggler"
      type="button" aria-controls="navbarSupportedContent" [attr.aria-expanded]="isnavbar"
      aria-label="Toggle navigation">
      <span class="navbar-toggler-icon-custom" [class.active]="isnavbar"></span>
    </button>
    @if(!sharedService.removeNavbarLinks){
    <div class="collapse navbar-collapse" [class.show]="isnavbar" id="navbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0 menu-one">
        @if(!isLoginPage && !isRegisterPage){
        <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
          <a class="nav-link" [routerLink]="routes.dashboard" (click)="navclose()">
            {{ 'NAVBAR.DASHBOARD' | translate }}
          </a>
        </li>
        <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
          <a class="nav-link" aria-expanded="false" [routerLink]="routes.appointments" (click)="navclose()"
            id="tour-appointment-nav">
            {{ 'NAVBAR.APPOINTMENTS' | translate }}
          </a>
        </li>
        <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
          <a class="nav-link" role="button" aria-expanded="false" [routerLink]="routes.membership" (click)="navclose()"
            id="tour-membership-nav">
            {{ 'NAVBAR.MEMBERSHIPS' | translate }}
          </a>
        </li>
        <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
          <a class="nav-link" role="button" aria-expanded="false" [routerLink]="routes.resources" (click)="navclose()"
            id="tour-resource-nav">
            {{ 'NAVBAR.RESOURCES' | translate }}
          </a>
        </li>
        }
      </ul>
      <ul class="navbar-nav separate-nav mb-2 mb-lg-0 aling-items-center align-self-center">
        <li class="nav-item hideonmobile">
          <a class="nav-link phone-btn" [href]="'tel:'+environment.phoneNumber" aria-expanded="false">
            <img [src]="sharedService.imagesUrl +  'icons/phone-icon-nav-update.svg'" alt="" />
            {{environment.phoneNumberToShow}}
          </a>
        </li>
        <div class="separate"></div>
        <li routerLinkActive="active" class="nav-item dropdown En-li dropdown En-main" routerLinkActive="active">
          <a routerLinkActive="active" class="nav-link phone-btn en-btn dropdown-toggle" href="#" id="navbarDropdown"
            role="button" data-bs-toggle="dropdown" aria-expanded="false">
            <span>
              <img width="17" [src]="sharedService.imagesUrl +  'icons/En.svg'" alt="DOWN ARROW">
              <span>{{currentLanguage.toUpperCase()}}</span>
            </span>
          </a>
          <ul class="dropdown-menu En-menue  bordered-menu-en mt-4" aria-labelledby="navbarDropdown">
            <div class="menu-mobile-btn-container">

            </div>
            <li>
              <a class="dropdown-item" (click)="setLanguage('en')">English (EN)</a>
            </li>
            <li class="center-li" routerLinkActive="active"><a class="dropdown-item" [routerLink]=""
                (click)="setLanguage('es'); ">Spanish (ES)
              </a></li>
            <li class="border-0 end-li  " routerLinkActive="active">
              <a class="dropdown-item end-btn" [routerLink]="" (click)="setLanguage('zh'); navclose()">
                Chinese (ZH)

              </a>
            </li>
          </ul>
        </li>
        @if(!isLoginPage && !isRegisterPage){


        @if(isUser){
        <li class="nav-item dropdown myaccountmenuli">
          <a class="nav-link dropdown-toggle myaccountmenu" href="#" id="navbarDropdown" role="button"
            data-bs-toggle="dropdown" aria-expanded="false">
            <span class="account-circle-parent">
              <span class="account-circle">{{ userInitials }}</span>
              {{ 'NAVBAR.MYACCOUNT' |
              translate }} </span>

          </a>
          <ul class="dropdown-menu account-ul bordered-menu" aria-labelledby="navbarDropdown">
            <div class="menu-mobile-btn-container">
              <button>
                <img width="17" [src]="sharedService.imagesUrl +  'icons/dropdown-arrow.svg'" alt="DOWN ARROW">
              </button>
              <button>
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                  <path
                    d="M17.8071 7.47668C17.9019 7.38204 18.065 7.38198 18.1597 7.47668C18.2542 7.57141 18.2543 7.73452 18.1597 7.82922L7.3335 18.6564L7.32764 18.6622L7.32178 18.6691C7.29153 18.7015 7.2321 18.7306 7.15674 18.7306C7.09236 18.7305 7.03213 18.7075 6.98096 18.6564C6.88622 18.5616 6.88622 18.3986 6.98096 18.3038L17.8071 7.47668Z"
                    fill="#494949" stroke="#494949" />
                  <path
                    d="M18.0403 19.2889C17.8503 19.2889 17.6603 19.2189 17.5103 19.0689L6.57004 8.1265C6.28004 7.8365 6.28004 7.3565 6.57004 7.0665C6.86004 6.7765 7.34004 6.7765 7.63004 7.0665L18.5703 18.009C18.8603 18.299 18.8603 18.7789 18.5703 19.0689C18.4203 19.2189 18.2303 19.2889 18.0403 19.2889Z"
                    fill="#494949" />
                </svg>
              </button>
            </div>
            <li><a class="dropdown-item " [routerLink]="routes.account" (click)="navclose()"> {{ 'NAVBAR.MYACCOUNT' |
                translate }}
              </a>
            </li>
            <li><a class="dropdown-item" [routerLink]="routes.familyInfo" (click)="navclose()">{{'NAVBAR.FAMILY_INFO' |
                translate}}</a></li>
            @if(!isMemberPortalOnly){
            <li><a class="dropdown-item" [routerLink]="routes.wallet" (click)="navclose()">{{'NAVBAR.WALLET'|
                translate}}</a></li>
            <li class="hideonmobile">
              <a class="dropdown-item d-flex align-items-center" (click)="changeTopBar()">
                {{'NAVBAR.VISITEWEB'| translate}} &nbsp;
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none"
                  style="max-width: 100%;height: auto;">
                  <path
                    d="M14.19 0.65625H5.81C2.17 0.65625 0 2.82625 0 6.46625V14.8363C0 18.4862 2.17 20.6562 5.81 20.6562H14.18C17.82 20.6562 19.99 18.4862 19.99 14.8463V6.46625C20 2.82625 17.83 0.65625 14.19 0.65625ZM15.25 10.9862C15.25 11.3962 14.91 11.7362 14.5 11.7362C14.09 11.7362 13.75 11.3962 13.75 10.9862V7.96625L6.03 15.6863C5.88 15.8363 5.69 15.9062 5.5 15.9062C5.31 15.9062 5.12 15.8363 4.97 15.6863C4.68 15.3963 4.68 14.9163 4.97 14.6263L12.69 6.90625H9.67C9.26 6.90625 8.92 6.56625 8.92 6.15625C8.92 5.74625 9.26 5.40625 9.67 5.40625H14.5C14.91 5.40625 15.25 5.74625 15.25 6.15625V10.9862Z"
                    fill="black" />
                </svg>
              </a>
            </li>
            }
            <li class="hideonmobile"><a class="dropdown-item" (click)="helperService.logoutFlow()"
                style="color: #ff3232 !important;">{{'NAVBAR.LOGOUT'| translate}}</a></li>
          </ul>
        </li>
        }
        }

      </ul>

      <ul class="navbar-nav mb-2 mb-lg-0 menu-three">
        @if(!isMemberPortalOnly){
        <li class="nav-item topbar-btn">
          <a (click)="changeTopBar()" class="btn btn-primary mobile-dashboard-btn" style="margin-right: 4px;">
            {{'NAVBAR.VISITEWEB'| translate}} &nbsp;
            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
              <path d="M10.2505 9.20286L16.4005 3.05286" stroke="white" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M17.0004 6.05288V2.45288H13.4004" stroke="white" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                d="M8.75049 2.45288H7.25049C3.50049 2.45288 2.00049 3.95288 2.00049 7.70288V12.2029C2.00049 15.9529 3.50049 17.4529 7.25049 17.4529H11.7505C15.5005 17.4529 17.0005 15.9529 17.0005 12.2029V10.7029"
                stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </a>
        </li>
        }
        <li class="nav-item topbar-btn">
          <a (click)="helperService.logoutFlow()" class="btn mobile-logout-btn">{{'NAVBAR.LOGOUT'| translate}}</a>
        </li>
      </ul>
    </div>
    }
  </div>
</nav>